<template>
  <section class="v dashboard">
    <metrics-overview
      v-if="currentUsage"
      :workload="Number(currentUsage.overall.occupied_spaces)"
      :max-val="Number(currentUsage.overall.total_parking_spaces)"
      :stream-data="streamData"
      :line-chart="lineChart"
      @load="onChartLoaded"
    ></metrics-overview>
    <parking-lot-map @parking-lot-creation="onParkingLotCreation"></parking-lot-map>
  </section>
</template>

<script>
import MetricsOverview from '../components/Dashboard/MetricsOverview.vue';
import ParkingLotMap from '../components/Dashboard/ParkingLotMap.vue';

export default {
  name: 'Dashboard',

  components: {
    MetricsOverview,
    ParkingLotMap,
  },

  data() {
    return {
      parkingLotCreation: false,
    };
  },

  computed: {
    currentUsage() {
      return this.$store.metrics.state.currentUsage;
    },
    streamData() {
      return this.$store.metrics.state.overview.stream;
    },
    lineChart() {
      return this.$store.metrics.state.overview.lineChart;
    },
  },

  methods: {
    onChartLoaded() {
      if (this.lineChart.datasets.length === 0) {
        this.$store.metrics.dispatch('GET_WORKLOAD');
      }
    },
    onParkingLotCreation(e) {
      this.parkingLotCreation = e;
    },
  },

  mounted() {
    this.$store.navigation.commit('SET_NAV_RIGHT_ELEMENTS', null);
    this.$store.navigation.commit('SET_NAV_TITLE', 'Element Smart Parking');
    this.$store.navigation.commit('SET_TABS', [
      { label: 'Dashboard', to: '/' },
      { label: 'Metriken', to: '/metrics' },
    ]);
    this.$store.parkingLots.dispatch('PARKING_LOT_SOCKET');
    this.$store.metrics.dispatch('GET_CURRENT_USAGE');
    this.$store.metrics.dispatch('GET_DAILY_STATS');
    this.$store.metrics.dispatch('GET_LATEST_EVENTS');
  },
};
</script>
